goog.provide('el8.ptdata.model.med.base');

goog.require('el8.model.base');
goog.require('el8.data.medications');
goog.require('el8.data.referencedPracticians');


el8.ptdata.model.med.base = function(spec) { this.populate(spec); };
el8.ptdata.model.med.base.inheritsFrom(el8_Entity);
el8.ptdata.model.med.base.makeDocument();

el8.ptdata.model.med.base.addIntProperty("threadId", true);
el8.ptdata.model.med.base.addDateTime("createDate", true);

el8.ptdata.model.med.base.addStringProperty("displayedMedicationName");

el8.ptdata.model.med.base.addIntProperty("medicationId", true);
el8.ptdata.model.med.base.addBoolean("rxDownload", false, false);

// Did not add prescribingUserId because it doesn't serve any purpose here
el8.ptdata.model.med.base.addIntProperty("prescribingPhysicianId", true);
el8.ptdata.model.med.base.addIntProperty("documentingPersonnelId");
el8.ptdata.model.med.base.addIntProperty("supervisingPhysicianId");
el8.ptdata.model.med.base.addStringProperty("rxDownloadPrescriberName");

el8.ptdata.model.med.base.prototype.getMedication = function() {
    return el8.data.medications.getById(this.getMedicationId());
};
el8.ptdata.model.med.base.prototype.getPrescribingPhysicianName = function() {
    if (!this.getPrescribingPhysicianId()) { return; }
    var physician = el8.data.referencedPracticians.getById(this.getPrescribingPhysicianId());
    return (physician) ? physician.getFullName() : '';
};
el8.ptdata.model.med.base.prototype.getDocumentingPersonnelName = function() {
    if (!this.getDocumentingPersonnelId()) { return; }
    var practician = el8.data.referencedPracticians.getById(this.getDocumentingPersonnelId());
    return (practician) ? practician.getFullName() : '';
};
el8.ptdata.model.med.base.prototype.getSupervisingPhysicianName = function() {
    if (!this.getSupervisingPhysicianId()) { return; }
    var physician = el8.data.referencedPracticians.getById(this.getSupervisingPhysicianId());
    return (physician) ? physician.getFullName() : '';
};
el8.ptdata.model.med.base.prototype.isByCurrUser = function() {
    return (el8.data.currUser.getStaffId() === this.getPrescribingPhysicianId());
};
el8.ptdata.model.med.base.prototype.isOtherPrescriberDocumented = function() {
    if (this.getDocumentingPersonnelId()) {
        return this.getDocumentingPersonnelId() !== this.getPrescribingPhysicianId();
    }
    return false;
};

